import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles((showScroll) => ({
  scrollToTop: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    position: 'fixed',
    zIndex: 1000,
    bottom: 75,
    right: 28,
    overflowX: 'hidden',
    background: 'transparent',
    ['@media (max-width:1024px)']: {
      right: 15,
    },
    ['@media (max-width:780px)']: {
      display: 'none',
    }
  },
  scrollArrowContainer: {
    position: 'relative',
    background: colors.orange2,
    display: 'inline-block',
    borderRadius: '60px',
    padding: '5px',
    marginRight: '3px',
    width: '40px',
    height: '40px',
  },
  scrollArrowIcon: {
    display: showScroll ? 'flex' : 'none',
    color: colors.white,
    fontSize: fontSize.h6,
    position: 'absolute',
    top: '42%',
    left: '42%',
    transform: 'translate(-35%, -35%)',
  },
}));


const ScrollToTop = () => {
  const [scrolling, setScrolling] = useState(false);
  const [scrollInitialValue, setScrollInitialValue] = useState(0);
  const scrollShowValue = 800;

  useEffect(() => {
    function onScroll() {
      let currentPosition = window.pageYOffset;
      const shouldScroll = currentPosition > scrollInitialValue;

      setScrolling(shouldScroll);
      setScrollInitialValue(currentPosition <= 0 ? 0 : currentPosition);
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollInitialValue]);

  const classes = useStyles();
  const scrollTop = () => window.scrollTo({top: 0, behavior: 'smooth'});

  return (
    <>
      {
        (scrollInitialValue > scrollShowValue) && (
        <div className={classes.scrollToTop} onClick={scrollTop}>
          <div className={classes.scrollArrowContainer}>
            <ArrowUpwardOutlinedIcon className={classes.scrollArrowIcon}/>
          </div>
        </div>
        )
      }
    </>
  );
}

export default ScrollToTop;
